import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { userPointChartApi } from "../../../utility/api/apiList";

import userType from "../../../redux/actions/user/userType";

import useAxios from "../../../hooks/useAxios";
import scrollToTop from "../../../libs/scrollToTop";
import { chartDateGenerator } from "../../../libs/chartDateGenerator";
import {
  getStateByID,
  userGenders,
  userTypes,
} from "../../../libs/getConstants";

import LoadingComponent from "../../../components/public/loading";
import ChartComponent from "../../../components/private/user/chartComponent";

import {
  ChartWrapper,
  ContainerUserInfo,
  HeaderSectionInfo,
  HeaderUserInfo,
  UserContainerInfo,
  UserInfo,
} from "./styledUserMainProfileContainer";
import { StyledTooltip } from "../../../style/base/base";

export default function UserMainProfileContainer() {
  //chart
  const [chartLastWeekDateArray, setChartLastWeekDateArray] = useState([]);
  const [chartCurrentWeekDateArray, setChartCurrentWeekDateArray] = useState(
    []
  );

  const [tooltipText, setTooltipText] = useState("کپی");
  const copyToClipBoard = (e) => {
    navigator.clipboard.writeText(e.target.innerText);
    setTooltipText("کپی شد!");
  };

  const constantsDetail = useSelector((state) => state.constantsDetail);
  const userDetail = useSelector((state) => state.userDetail);
  const dispatch = useDispatch();
  const {
    data: currentWeekData,
    error: currentWeekError,
    isLoaded: currentWeekIsLoaded,
    run: currentWeekRun,
  } = useAxios({
    url: userPointChartApi,
    params: {
      week: 0,
    },
  });
  const {
    data: lastWeekData,
    error: lastWeekError,
    isLoaded: lastWeekIsLoaded,
    run: lastWeekRun,
  } = useAxios({
    url: userPointChartApi,
    params: {
      week: 1,
    },
  });

  const types = userTypes();
  const genders = userGenders();

  useEffect(() => {
    document.title = "پروفایل";
    scrollToTop();

    dispatch({ type: userType.UPDATE_USER_DETAIL });
    currentWeekRun().then((response) => {
      const data = chartDateGenerator(response.data.fri, response.data.sat);
      setChartCurrentWeekDateArray(data);
    });

    lastWeekRun().then((response) => {
      const data = chartDateGenerator(response.data.fri, response.data.sat);
      setChartLastWeekDateArray(data);
    });
  }, []);

  if (constantsDetail.loading) {
    return <LoadingComponent />;
  } else if (constantsDetail.error || !userDetail.isLogin) {
    return (
      <div className="mt-3 text-center">
        اتفاقی افتاده است لطفا دوباره امتحان کنید.
      </div>
    );
  } else {
    return (
      <div className="d-flex flex-column justify-content-center">
        <div className="mx-auto px-2">
          <HeaderSectionInfo className="text-center mb-3">
            اطلاعات من
          </HeaderSectionInfo>
          <ContainerUserInfo>
            <UserContainerInfo>
              <HeaderUserInfo>نام و نام‌خانوادگی:</HeaderUserInfo>
              <UserInfo>{`${userDetail.userDetail[0].first_name}  ${userDetail.userDetail[0].last_name}`}</UserInfo>
            </UserContainerInfo>
            <UserContainerInfo>
              <HeaderUserInfo>شناسه کاربری:</HeaderUserInfo>
              <UserInfo>
                <StyledTooltip title={tooltipText} placement="left">
                  <span
                    className="text-center profile_code"
                    onClick={(e) => copyToClipBoard(e)}
                    onMouseLeave={() => setTooltipText("کپی")}
                  >
                    {userDetail.userDetail[0].usermeta.profile_code}
                  </span>
                </StyledTooltip>
              </UserInfo>
            </UserContainerInfo>
            <UserContainerInfo>
              <HeaderUserInfo>نوع کاربر:</HeaderUserInfo>
              <UserInfo>
                {types[userDetail.userDetail[0].usermeta.type]}
              </UserInfo>
            </UserContainerInfo>
            <UserContainerInfo>
              <HeaderUserInfo>نام مدرسه:</HeaderUserInfo>
              <UserInfo>
                {userDetail.userDetail[0].usermeta.school_name
                  ? userDetail.userDetail[0].usermeta.school_name
                  : "---"}
              </UserInfo>
            </UserContainerInfo>
            <UserContainerInfo>
              <HeaderUserInfo>شماره همراه:</HeaderUserInfo>
              <UserInfo>
                {userDetail.userDetail[0].usermeta.phone
                  ? userDetail.userDetail[0].usermeta.phone
                  : "---"}
              </UserInfo>
            </UserContainerInfo>
            <UserContainerInfo>
              <HeaderUserInfo>کد ملی:</HeaderUserInfo>
              <UserInfo>
                {userDetail.userDetail[0].usermeta.nid
                  ? userDetail.userDetail[0].usermeta.nid
                  : "---"}
              </UserInfo>
            </UserContainerInfo>
            <UserContainerInfo>
              <HeaderUserInfo>جنسیت کاربر:</HeaderUserInfo>
              <UserInfo>
                {genders[userDetail.userDetail[0].usermeta.gender]}
              </UserInfo>
            </UserContainerInfo>
            <UserContainerInfo>
              <HeaderUserInfo>استان:</HeaderUserInfo>
              <UserInfo>
              {userDetail.userDetail[0].usermeta.state
                  ? getStateByID(userDetail.userDetail[0].usermeta.state)
                  : "---"}
              </UserInfo>
            </UserContainerInfo>
          </ContainerUserInfo>
        </div>
        <ChartWrapper className="px-2 mt-5">
          <HeaderSectionInfo className="text-center mb-3">
            نمودار پیشرفت من
          </HeaderSectionInfo>
          <div className="div-container-inf-profile mx-auto p-3">
            <ChartComponent
              chartLastWeekDateArray={chartLastWeekDateArray}
              chartDataPreviouseWeekArray={lastWeekData?.data}
              chartDataCurrentWeekArray={currentWeekData?.data}
              chartCurrentWeekDateArray={chartCurrentWeekDateArray}
            />
          </div>
        </ChartWrapper>
      </div>
    );
  }
}
